import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { CREATE_UNIT, CREATE_UNIT_FAIL, CREATE_UNIT_SUCCESS, CreateUnitActionType } from '../redux/unitsReducer'

function* CreateUnitFlow(action: CreateUnitActionType): Generator<any, void, any> {
  try {
    const params = { unit: action.payload }
    const response = yield call(apiCall, { endpoint: '/tutors/units', method: 'POST', params })
    yield put(CREATE_UNIT_SUCCESS(response))
  } catch (error) {
    yield put(CREATE_UNIT_FAIL())
    console.log(error)
  }
}

export default function* CreateUnitSaga(): Generator<any, void, any> {
  yield takeLatest([CREATE_UNIT], CreateUnitFlow)
}
